import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";

@Entity('vehicle-master')
export class VehicleMaster {

  @PrimaryGeneratedColumn("increment",{name:'vehicle_id'})
  vehicleId:number;
  
  @Column("varchar",{
      nullable:false,
      length:20,
      name:"registration_number"
      })
  @Index({unique:true})
  registrationNumber:string;
  @Column("varchar",{
      nullable:false,
      length:30,
      name:"vehicle_name"
      })
  // @Index({unique:true})
  vehicleName:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
  
  @Column("boolean", {
    default: true,
    name: "is_available"
  })
  isAvailable: boolean;
}
